
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Mason_Classification_of_Radial_Head_Fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Mason_Classification_of_Radial_Head_Fractures.vue